(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CentroDocenteDetailController', CentroDocenteDetailController);

    CentroDocenteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CentroDocente'];

    function CentroDocenteDetailController($scope, $rootScope, $stateParams, previousState, entity, CentroDocente) {
        var vm = this;

        vm.centroDocente = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:centroDocenteUpdate', function(event, result) {
            vm.centroDocente = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
